module.exports = __webpack_public_path__ + "static/assets/7d69e13c9d4a03ab66398bc2861a6f92.gif";